import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=526b5ccc&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=526b5ccc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526b5ccc",
  null
  
)

export default component.exports